import { render, staticRenderFns } from "./UpdateProduct.vue?vue&type=template&id=13f0d154&lang=pug&"
import script from "./UpdateProduct.vue?vue&type=script&lang=ts&"
export * from "./UpdateProduct.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports